import React, { useState } from 'react';
import Equipment from './equipment';
import Controller from './controller';
import Transformer from './transformer';
import HarmonicFilter from './harmonic-filter';
import { useAppSelector } from '../../../store/hooks/StoreHooks';
import Error from '../../../assets/icons/Error';

const SurfaceEquipment: React.FC = () => {

    const { loading } = useAppSelector(
        (state) => state?.surfaceEquipment
    );

    const [showError, setShowError] = useState<string[]>([]);

    return (
        <>
            <div className='flex flex-col justify-center item-center w-full h-full gap-[16px]'>
                {
                    showError?.length > 0 && showError?.map(item => {
                        return (
                            <div className="flex items-center p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-error-500 border-darkcolor-400">
                                <Error />
                                <p className="text-[14px] font-bold leading-[20px] text-neutral-25">
                                    {item}
                                </p>
                            </div>
                        )
                    })
                }
                <Equipment />
                <Controller showError={showError} setShowError={setShowError} />
                <Transformer />
                <HarmonicFilter />
            </div>
        </>)
}

export default SurfaceEquipment;
